import { createSlice } from "@reduxjs/toolkit";
import AdminApi from "../../../api/AdminApi";
import { showNotification } from "./notification";

type State = {
    data: Array<Object>;
    paging: Object | null;
    isLoading: boolean;
    isUpdating: boolean;
    troubleLoading: boolean;
    error: Object | null;
    timestamp: number;
    isDirty: boolean;
};

const initialState = {
    data: [],
    paging: null,
    isLoading: false,
    isUpdating: false,
    troubleLoading: false,
    error: null,
    timestamp: 0,
    isDirty: false,
};

const goalArchive = createSlice({
    name: "goalArchive",
    initialState,
    reducers: {
        fetchGoalArchiveStart: (state: State) => {
            state.isLoading = true;
            state.error = null;
            state.isDirty = false;
        },
        fetchGoalArchiveSuccess: (state: State, action) => {
            if (action.payload && action.payload.data) {
                state.data = action.payload.data;
            }

            state.paging = action.payload && action.payload.paging ? action.payload.paging : null;
            state.troubleLoading = false;
            state.isLoading = false;
            state.error = false;
            state.timestamp = Date.now();
        },
        fetchGoalArchiveTroubleLoading: (state: State, action) => {
            state.isLoading = false;
            state.troubleLoading = true;
        },
        fetchGoalArchiveFailed: (state: State, action) => {
            state.isLoading = false;
            state.error = action.payload;
        }
    },
});

// Actions
export const {
    fetchGoalArchiveStart,
    fetchGoalArchiveSuccess,
    fetchGoalArchiveFailed,
    fetchGoalArchiveTroubleLoading
} = goalArchive.actions;

export default goalArchive.reducer;

// Thunk
export const fetchGoalArchive = (id: any, page?: number) => async (dispatch: Function) => {
    try {
        dispatch(fetchGoalArchiveStart());
        const api = new AdminApi();
        const result = await api.getGoalArchive(id, page || 1);
        if (result === "trouble loading") {
            dispatch(fetchGoalArchiveTroubleLoading(result))
        } else {
            dispatch(fetchGoalArchiveSuccess(result));
        }
    } catch (err: any) {
        dispatch(fetchGoalArchiveFailed(err));
        dispatch(showNotification("error", err.message));
    }
};
